var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgBandcamp = function SvgBandcamp(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25C6.624 2.25 2.25 6.624 2.25 12C2.25 17.376 6.624 21.75 12 21.75C17.376 21.75 21.75 17.376 21.75 12C21.75 6.624 17.376 2.25 12 2.25ZM12 3.75C16.5487 3.75 20.25 7.45125 20.25 12C20.25 16.5487 16.5487 20.25 12 20.25C7.45125 20.25 3.75 16.5487 3.75 12C3.75 7.45125 7.45125 3.75 12 3.75ZM10.0373 9L7.03725 15H13.9628L16.9628 9H10.0373ZM10.9627 10.5H14.5372L13.0372 13.5H9.46275L10.9627 10.5Z",
    fill: "#333333"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgBandcamp);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDIuMjVDNi42MjQgMi4yNSAyLjI1IDYuNjI0IDIuMjUgMTJDMi4yNSAxNy4zNzYgNi42MjQgMjEuNzUgMTIgMjEuNzVDMTcuMzc2IDIxLjc1IDIxLjc1IDE3LjM3NiAyMS43NSAxMkMyMS43NSA2LjYyNCAxNy4zNzYgMi4yNSAxMiAyLjI1Wk0xMiAzLjc1QzE2LjU0ODcgMy43NSAyMC4yNSA3LjQ1MTI1IDIwLjI1IDEyQzIwLjI1IDE2LjU0ODcgMTYuNTQ4NyAyMC4yNSAxMiAyMC4yNUM3LjQ1MTI1IDIwLjI1IDMuNzUgMTYuNTQ4NyAzLjc1IDEyQzMuNzUgNy40NTEyNSA3LjQ1MTI1IDMuNzUgMTIgMy43NVpNMTAuMDM3MyA5TDcuMDM3MjUgMTVIMTMuOTYyOEwxNi45NjI4IDlIMTAuMDM3M1pNMTAuOTYyNyAxMC41SDE0LjUzNzJMMTMuMDM3MiAxMy41SDkuNDYyNzVMMTAuOTYyNyAxMC41WiIgZmlsbD0iIzMzMzMzMyIvPgo8L3N2Zz4K";